import { useLayoutEffect } from 'react';
import { CardsList } from '../../components';
import './Home.scss';

export const Home = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <header className='container mb-5'>
        <h2>Time Calculators</h2>
        <p className='fs-5 mb-0'>
          A collection of over 9+ useful calculators for counting time,
          calendar, days etc.
        </p>
      </header>
      <div className='home'>
        <CardsList />
      </div>
    </>
  );
};
